// Verifica se é um file.
export const isFile = (object) => {
    return object instanceof File;
}

export const isNumber = (value) => {
    // Expressão regular para verificar se a string contém apenas dígitos numéricos
    const regex = /^\d+$/;
    return regex.test(value);
}

export const validateEmail = (email) => {
    // Expressão regular para validar um endereço de e-mail básico
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

// Verifica se é um dispositivo móvel
export const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Verifica padrões comuns de dispositivos móveis
    return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}